import { valStoreAPI } from '@/api';
import { processValStore, checkDuplicateAndReturnItem } from '@/utils/helpers.js';
import Vue from 'vue';

const state = {
    keyVals: {},
    loading: false,
};

const mutations = {
    setValue(state, payload) {
        Vue.set(state.keyVals, payload.key, payload.value);
    },
    initStore(state, payload) {
        state.keyVals = payload;
    },
    setLoading(state, value) {
        state.loading = value;
    },
};

const actions = {
    async setKeyValue({ commit, state }, data) {
        const { isDuplicate, item } = checkDuplicateAndReturnItem(state.keyVals[data.valStoreKey], data.value);
        if (!isDuplicate) {
            commit('setValue', { key: data.valStoreKey, value: item });
            const body = {
                key: data.valStoreKey,
                value: data.value,
            };
            valStoreAPI.updateRecentsAPI(body);
        }
    },
    async initializeKeyValStore({ commit, rootState }) {
        commit('setLoading', true);
        const globalScopeVals = await valStoreAPI.getGlobalScopedValsAPI().catch((err) => {
            commit('setLoading', false);
            return err;
        });
        const userScopeVals = await valStoreAPI.getUserScopedValsAPI().catch((err) => {
            commit('setLoading', false);
            return err;
        });
        const data = processValStore(globalScopeVals.data.keys, userScopeVals.data.keys, rootState.users.user.userId);
        commit('initStore', data);
        commit('setLoading', false);
    },
};

export default {
    state,
    mutations,
    actions,
};
